(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var list = document.querySelector("[data-clients-list]");
    var moreButton = document.querySelector("[data-clients-more]");
    if (!list) {
      return;
    }

    var parsePositiveInt = function (value, fallback) {
      var parsed = parseInt(value, 10);
      if (!isNaN(parsed) && parsed > 0) {
        return parsed;
      }
      return fallback;
    };

    var isFirstBatch = true;
    var currentIndex = 0;
    var clients = []; 
    var isLoading = false;
    var hasMore = true;
    var revealQueue = [];
    var revealRunning = false;
    var clientsInView = false;
    var revealAfterLoadPending = false;
    var isClientsPage =
      document.body && document.body.classList.contains("page--clients");
    var isHomePage =
      document.body && document.body.classList.contains("page--index");

    var isMobile =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(max-width: 640px)").matches;
    var initialCount = parsePositiveInt(
      list.getAttribute("data-clients-initial"),
      isClientsPage ? 30 : 15
    );
    if (!isClientsPage && isMobile) {
      initialCount = Math.min(initialCount, 14);
    }
    var moreCountAttr =
      list.getAttribute("data-clients-more-count") ||
      list.getAttribute("data-clients-more");
    var moreCount = parsePositiveInt(moreCountAttr, isClientsPage ? 15 : initialCount);

    if (isClientsPage) {
      clientsInView = true;
    }

    var normalizeString = function (value) {
      if (typeof value !== "string") {
        return "";
      }
      return value.trim();
    };

    var uniq = function (items) {
      var seen = {};
      return items.filter(function (item) {
        if (!item || seen[item]) {
          return false;
        }
        seen[item] = true;
        return true;
      });
    };

    var getUploadOrigins = function () {
      var origins = [];
      var listBase = normalizeString(list && list.getAttribute("data-clients-base-url"));
      if (listBase) {
        origins.push(listBase);
      }

      var origin = (window.location && window.location.origin) || "";
      var host = (window.location && window.location.hostname) || "";
      var port = (window.location && window.location.port) || "";
      if (!listBase) {
        if ((host === "localhost" || host === "127.0.0.1") && port !== "44362") {
          origins.push("https://localhost:7152");
          if (origin) {
            origins.push(origin);
          }
        } else if (host.indexOf("dnbtest") !== -1) {
          origins.push("https://preprodcms.dnbtest.com");
          if (origin) {
            origins.push(origin);
          }
        } else if (origin) {
          origins.push(origin);
        }
      }
      origins.push("https://dreamsandbytes.com");
      return uniq(origins);
    };

    var uploadOrigins = getUploadOrigins();

    var resolveUploadUrl = function (path, originIndex) {
      if (!path) {
        return "";
      }
      if (/^https?:\/\//i.test(path) || path.indexOf("data:") === 0) {
        return path;
      }
      if (path.indexOf("//") === 0) {
        return (window.location ? window.location.protocol : "https:") + path;
      }
      if (path.charAt(0) === "/" && path.indexOf("/Upload/") === 0 && uploadOrigins.length) {
        var origin = uploadOrigins[Math.min(originIndex || 0, uploadOrigins.length - 1)];
        return origin.replace(/\/$/, "") + path;
      }
      return path;
    };

    var hideMoreButton = function () { 
      if (isHomePage) {
        return;
      }
      if (!moreButton) {
        return; 
      }
      moreButton.setAttribute("disabled", "disabled");
      moreButton.style.display = "none";
    };

    var runRevealBatch = function (targets) {
      if (!targets.length) {
        revealRunning = false;
        return;
      }

      if (!window.gsap) {
        targets.forEach(function (target) {
          target.style.opacity = "";
          target.style.transform = "";
          var content = target.querySelector(".clients__logo-content");
          if (content) {
            content.style.transform = "";
          }
        });
        revealRunning = false;
        return;
      }

      var revealNext = function (index) {
        if (index >= targets.length) {
          revealRunning = false;
          if (revealQueue.length) {
            startReveal();
          }
          return;
        }

        var target = targets[index];
        var content = target.querySelector(".clients__logo-content");
        window.gsap.to(target, {
          opacity: 1,
          scale: 1,
          duration: 0.3,
          ease: "power3.out",
          onComplete: function () {
            revealNext(index + 1);
          }
        });

        if (content) {
          window.gsap.to(content, {
            scale: 1,
            duration: 0.3,
            ease: "power3.out"
          });
        }
      };

      revealNext(0);
    };

    var startReveal = function () {
      if (
        !revealAfterLoadPending &&
        window.DNB &&
        !window.DNB.loadingComplete &&
        typeof window.DNB.onLoadComplete === "function"
      ) {
        revealAfterLoadPending = true;
        window.DNB.onLoadComplete(function () {
          revealAfterLoadPending = false;
          startReveal();
        });
        return;
      }

      if (revealRunning || !clientsInView || !revealQueue.length) {
        return;
      }

      revealRunning = true;
      var batch = revealQueue.slice();
      revealQueue = [];
      runRevealBatch(batch);
    };

    var queueReveal = function (targets) {
      if (!targets || !targets.length) {
        return;
      }

      var newTargets = [];
      targets.forEach(function (target) {
        if (target.dataset.clientsRevealQueued === "true") {
          return;
        }
        target.dataset.clientsRevealQueued = "true";
        if (window.gsap) {
          target.style.opacity = "0";
          target.style.transform = "scale(0.3)";
          target.style.transformOrigin = "center";
          var content = target.querySelector(".clients__logo-content");
          if (content) {
            content.style.transform = "scale(1.4)";
            content.style.transformOrigin = "center";
          }
        }
        newTargets.push(target);
      });

      if (!newTargets.length) {
        return;
      }

      revealQueue = revealQueue.concat(newTargets);
      startReveal();
    };

    var createLogoItem = function (client) {
      var li = document.createElement("li");
      li.className = "clients__logo";

      var inner = document.createElement("div");
      inner.className = "clients__logo-inner";
      li.appendChild(inner);

      var contentWrap = document.createElement("div");
      contentWrap.className = "clients__logo-content";
      inner.appendChild(contentWrap);

      var name = normalizeString(client && client.name);
      var logo = normalizeString(client && client.logo);
      var logoHover = normalizeString(client && (client.logo_hover || client.logoHover));
      var webUrl = normalizeString(client && (client.webUrl || client.webURL || client.WebUrl || client.website));

      if (name) {
        li.setAttribute("aria-label", name);
      }

      var contentHost = contentWrap;
      if (webUrl) {
        var link = document.createElement("a");
        link.className = "clients__logo-link";
        link.href = webUrl;
        if (name) {
          link.setAttribute("aria-label", name);
        }
        contentWrap.appendChild(link);
        contentHost = link;
      }

      var appendFallbackText = function () {
        if (!name) {
          return;
        }
        if (!contentHost.querySelector(".clients__logo-text")) {
          var fallback = document.createElement("span");
          fallback.className = "clients__logo-text";
          fallback.textContent = name;
          contentHost.appendChild(fallback);
        }
      };

      if (logo) {
        var img = document.createElement("img");
        img.dataset.currentPath = logo;
        img.dataset.originIndex = "0";
        img.src = resolveUploadUrl(logo, 0);
        img.alt = name || "";
        img.loading = "lazy";
        img.decoding = "async";
        img.addEventListener("error", function () {
          var currentPath = img.dataset.currentPath || "";
          var originIndex = parseInt(img.dataset.originIndex || "0", 10);
          if (currentPath.indexOf("/Upload/") === 0 && originIndex + 1 < uploadOrigins.length) {
            img.dataset.originIndex = String(originIndex + 1);
            img.src = resolveUploadUrl(currentPath, originIndex + 1);
            return;
          }
          if (currentPath === logoHover && logo) {
            img.dataset.currentPath = logo;
            img.dataset.originIndex = String(originIndex);
            img.src = resolveUploadUrl(logo, originIndex);
            return;
          }
          img.remove();
          appendFallbackText();
        });

        if (logoHover && logoHover !== logo) {
          var swapLogo = function (useHover) {
            var nextPath = useHover ? logoHover : logo;
            var originIndex = parseInt(img.dataset.originIndex || "0", 10);
            if (img.dataset.currentPath === nextPath) {
              return;
            }
            img.dataset.currentPath = nextPath;
            img.dataset.originIndex = String(originIndex);
            img.src = resolveUploadUrl(nextPath, originIndex);
          };
          contentHost.addEventListener("mouseenter", function () {
            swapLogo(true);
          });
          contentHost.addEventListener("mouseleave", function () {
            swapLogo(false);
          });
          contentHost.addEventListener("focus", function () {
            swapLogo(true);
          });
          contentHost.addEventListener("blur", function () {
            swapLogo(false);
          });
        }

        contentHost.appendChild(img);
      } else if (name) {
        appendFallbackText();
      }

      return li;
    };

    var renderNext = function () {
      if (!clients.length) {
        return;
      }

      var batchSize = isFirstBatch ? initialCount : moreCount;
      var nextItems = clients.slice(currentIndex, currentIndex + batchSize);
      if (!nextItems.length) {
        hasMore = false;
        hideMoreButton();
        return;
      }

      var fragment = document.createDocumentFragment();
      nextItems.forEach(function (client) {
        fragment.appendChild(createLogoItem(client));
      });
      list.appendChild(fragment);
      currentIndex += nextItems.length;
      isFirstBatch = false;

      if (currentIndex >= clients.length) {
        hasMore = false;
        hideMoreButton();
      }

      var newLogos = Array.prototype.slice.call(
        list.querySelectorAll(".clients__logo-inner")
      );
      queueReveal(newLogos);

      window.requestAnimationFrame(function () {
        if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }
        if (window.DNB && window.DNB.locoScroll) {
          window.DNB.locoScroll.update();
        }
      });
    };

    var loadData = function () {
      if (isLoading) {
        return;
      }
      isLoading = true;

      // console.log("[loader] fetch start", "/Client-service");
      var request = fetch("/Client-service")
        .then(function (response) {
          if (!response.ok) {
            throw new Error("Client data not found");
          }
          return response.json();
        })
        .then(function (data) {
          var rawPayload = Array.isArray(data) ? data : data.data;
          // console.log("[loader] fetch success", "/Client-service", {
          //   items: Array.isArray(rawPayload) ? rawPayload.length : null
          // });
          var payload = Array.isArray(data) ? data : data.data;
          if (!Array.isArray(payload)) {
            hasMore = false;
            hideMoreButton();
            return;
          }
          if (isHomePage) {
            payload = payload.filter(function (item) {
              if (!item) {
                return false;
              }
              var flag = item.isShowHomePege;
              if (typeof flag === "string") {
                flag = flag.toLowerCase() === "true";
              }
              return flag === true;
            });
          }
          clients = payload;
          renderNext();
        })
        .catch(function (error) {
          // console.log("[loader] fetch failed", "/Client-service", error);
          hasMore = false;
          hideMoreButton();
        })
        .finally(function () {
          isLoading = false;
        });

      if (window.DNB && typeof window.DNB.registerLoadTask === "function") {
        window.DNB.registerLoadTask(request);
      }
    };

    loadData();

    if (!isClientsPage && window.gsap && window.ScrollTrigger) {
      var revealTrigger = {
        trigger: list,
        start: "top 80%",
        invalidateOnRefresh: true,
        once: true,
        onEnter: function () {
          clientsInView = true;
          startReveal();
        }
      };

      if (window.DNB && window.DNB.scroller) {
        revealTrigger.scroller = window.DNB.scroller;
      }

      window.ScrollTrigger.create(revealTrigger);
    } else if (!isClientsPage && "IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              clientsInView = true;
              startReveal();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.3 }
      );

      observer.observe(list);
    } else if (!isClientsPage) {
      clientsInView = true;
    }

    if (moreButton) {
      moreButton.addEventListener("click", function (event) {
        event.preventDefault();
        if (isLoading || !hasMore) {
          return;
        }
        renderNext();
      });
    }
  });
})();
